module.exports = __webpack_public_path__ + "img/christine-new-profile.1569f1a8.png";